import lozad from 'lozad/dist/lozad.js';

'use strict';

// Add debounce function
window.debounce = function(func, wait) {
    let timeout;
    return function executedFunction(...args) {
        const later = () => {
            clearTimeout(timeout);
            func(...args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    };
};

/**
 * Library for reading reading ajax content
 */
class udAjaxListing {


    /**
     * Initialisation function
     */
    constructor(element) {
        
        // store element
        this.ajax_listing_element = element;

        // variable to store filter options
        this.filter_args = {};
        
        // set initial page for ajax request
        this.items_page = 1;

        // selector where the results will get populated
        this.results_selector = $(this.ajax_listing_element).find('.items-wrapper');

        // indicator to signify whether to clear results
        this.clear_results_when_data_loaded = false;

        // set items loading false now
        this.items_loading = false;

        // set ajax url
        this.ajax_url = false;

        // retrieve current pages featured post id
        this.retrieve_page_featured();

        // retrieve filter args
        this.retrieve_filter_args();

        // listen for other events
        this.event_listener();

        // listen for filter interactions
        this.filter_listener();

    }


    /**
     * Listen for other events
     */
    event_listener() {

        // instantiate a copy of self when out of scope
        let that = this;

        // ajax data request started
        $(that.ajax_listing_element).on('ud_ajax_request_started', function () {
            $(that.ajax_listing_element).addClass('ajax-loading');
        });

        // ajax data request completed
        $(that.ajax_listing_element).on('ud_ajax_request_complete', function () {
            $(that.ajax_listing_element).removeClass('ajax-loading');
            // Re observe lozad to find newly added items
            var observer = lozad();
            observer.observe();
        });

        // get next page of feed when `load more` button clicked
        $(this.ajax_listing_element).find(".ajax-load-more").click(function () {
            that.load_next_data();
        });

        // load initial first page of data
        $(window).on('load', function () {
            that.load_initial_data();
        });

    }


    /**
     * Listen for filter button clicks
     */
    filter_listener() {

        // instantiate a copy of self when out of scope
        let that = this;

        // listen for filter button updates
        $(this.ajax_listing_element).on('ud_filter_change', window.debounce(function () {

            // reset filter arguments
            that.reset_filter_args();

            // retrieve base filter args
            that.retrieve_filter_args();

            // build filter arguments set by user on filter bar
            that.retrieve_user_filter_args();

            // reload data
            that.get_items_data();

        }, 500));

    }


    /**
     * Reset filter args triggered when user changed or page loaded
     */
    reset_filter_args() {

        // reset item page to be first
        this.items_page = 1;

        // reset item counter
        this.iclass = 1;

        // clear last results
        this.clear_results_when_data_loaded = true;

        // reset filter args variable as we will now re-build it
        this.filter_args = {};

    }


    /**
     * Retrieve pages featured post id
     */
    retrieve_page_featured() {
        if (typeof window.page_featured_post !== 'undefined') {
            this.filter_args['post__not_in'] = window.page_featured_post;
        }
    }


    /**
     * Retrieve filter args stored in `.block-ajax-listing` elements attributes and add to base args
     */
    retrieve_filter_args() {

        // instantiate a copy of self when out of scope
        let that = this;

        let e_data = $(this.ajax_listing_element).data();
        for(let key in e_data){
            // set ajax url else add value filter args
            if ('ajaxUrl' == key) {
                if (!that.ajax_url) {
                    that.ajax_url = e_data[key];
                }
            } else {
                that.filter_args[key] = e_data[key];
            }
        }
    }


    /**
     * Build filter args variable set by user
     */
    retrieve_user_filter_args() {

        // instantiate a copy of self when out of scope
        let that = this;

        // loop through filter bar options and add to query args
        $(this.ajax_listing_element).find(".ajax-filter-option.active").each(function () {
            let key = $(this).attr('data-filter-key');
            let value = $(this).attr('data-filter-value');
            if (value != null && value) {

                // if not set in args then setup as array
                if (typeof that.filter_args[key] === 'undefined') {
                    that.filter_args[key] = [];
                }

                // push into filter args
                that.filter_args[key].push(value);

            }
        });

    }


    /**
     * Load initial data
     */
    load_initial_data() {

        // build args for query
        this.retrieve_filter_args();

        // build filter arguments set by user on filter bar
        this.retrieve_user_filter_args();

        // load data
        this.get_items_data();

    }


    /**
     * Load next page of data
     */
    load_next_data() {

        // load data
        this.get_items_data();

    }


    /**
     * Get items data function
     */
    get_items_data() {

        // instantiate a copy of self when out of scope
        let that = this;

        // signify loading
        this.items_loading = true;

        // trigger ajax event started
        $(this.ajax_listing_element).trigger("ud_ajax_request_started");

        // build ajax url
        let query_url = this.ajax_url + '?action=ajax_listing_feed&p=' + that.items_page;

        // ajax request for data
        this.xhr = $.ajax({
            url: query_url,
            data: {
                filters: that.filter_args,
                p: that.items_page,
            },
            type: 'POST',
            beforeSend: function () {
                if (that.xhr != null) {
                    that.xhr.abort();
                }
            },
            success: function (data) {

                // if indicator set to clear results grid
                if (that.clear_results_when_data_loaded) {

                    // reset indicator
                    that.clear_results_when_data_loaded = false;

                    // clear results
                    $(that.results_selector).html('');

                }

                // read json feed
                data = JSON.parse(data);

                // if feed now empty don't load more
                if ($.isEmptyObject(data.items)) {
                    that.items_data_finished = true;
                    return false;
                }

                // generate item grid html
                $.each(data.items, function (index, value) {

                    // append items to grid
                    $(that.results_selector).append(value.html);

                    // count item
                    that.iclass++;

                });

                // set next page ready for next ajax data load
                that.items_page++;

                // set loading false
                that.items_loading = false;

                // load in any html fragments
                if (typeof data.fragments !== "undefined") {
                    that.load_fragments(data.fragments);
                }

                // show load more posts button if ajax feed has more
                if (data.loaded_count < data.count && data.loaded_count > 0) {
                    $(that.ajax_listing_element).find('.ajax-load-more-wrapper').fadeIn();
                } else {
                    $(that.ajax_listing_element).find('.ajax-load-more-wrapper').fadeOut();
                }

                // trigger ajax event completed
                $(that.ajax_listing_element).trigger("ud_ajax_request_complete");

            },

        });

    }

}
export default udAjaxListing

// setup global variable to store ajax listing objects
window.block_ajax_listing = {};

// find all ajax listing blocks and create new instance for each
$( ".block-ajax-listing" ).each(function( i ) {
    window.block_ajax_listing[i] = new udAjaxListing(this);
});